import COLOR from "../../../constants/colors";

const styles = {
  whiteBackground: {
    marginBottom: 16,
    marginLeft: 10,
  },

  icon: {
    marginRight: 16,
    fontSize: 24,
  },
  item: {
    marginBottom: 16,
  },
};

export default styles;
